import jwt_decode from 'jwt-decode';

export const hasJWT = () => {
    return localStorage.getItem("token") ? true : false
};

export const getProfile = () => {
    try {
        const token = localStorage.getItem("token");
        if (!token) return null;
        return jwt_decode(token);
    } catch (error) {
        console.error("Error decoding token:", error);
        return null;
    }
}

export const resetToken = () => {
    localStorage.removeItem("token");
}   


export const setToken = (token) => {
    if (token) {
        localStorage.setItem("token", token);
    }
}

export const getToken = () => {
    return localStorage.getItem("token");
}
